import React, { useEffect, useState, useCallback } from 'react'

const ImportUserArticleForm = ({ props }) => {
  const [userArticles, setUserArticles] = useState([])
  const [error, setError] = useState(null)

  const getFetchOptions = (data) => ({
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
    },
    body: JSON.stringify({ user_articles: data })
  });

  const handleErrors = (response) => {
    if (!response.ok) {
      // throw new Error('データの確認に失敗しました');
      setError('データの確認に失敗しました');
    }
    return response;
  };

  const confirmData = (data) => {
    try {
      setError(null);
      fetch('/manage/user_articles/verify_user_article_csv_data',getFetchOptions(data))
        .then(handleErrors)
        .then(response => response.json())
        .then(responseData => {
        if (responseData['error']) {
          setError(responseData['error']['message']);
        } else {
          setError(null);
          setUserArticles(responseData['user_articles']);
        }
      });
    } catch (error) {
      setError(error);
    }
  };

  const validateFile = (file) => {
    if (!file.name.endsWith('.csv') || file.type !== 'text/csv') {
      throw new Error('CSVファイルを選択してください');
    }
    if (file.size > 10000000) { // 10MB limit
      throw new Error('ファイルサイズが大きすぎます');
    }
    if (file.size === 0) {
      throw new Error('ファイルが空です');
    }
  }

  const parseCSV = (data) => {
    const lines = data.split(/\r\n|\n/);
    const values = lines.map(line => line.split(','));
    values.shift(); // Remove the header row
    return values.map(value => {
      return {
        apartment_id: value[0],
        article_name: value[1],
        room: value[2],
        name: value[3],
        status: value[4],
      }
    });
  }

  const onChangeUserArticleFile = useCallback(
    (e) => {
      try {
        const file = e.target.files[0];
        validateFile(file);

        const reader = new FileReader();
        reader.onload = () => {
          const data = reader.result;
          const articles = parseCSV(data);
          confirmData(articles);
        }
        reader.readAsText(file);
      } catch (error) {
        setError(error.message);
      }
    }
  )

  const updateUserArticles = () => {
    const flattenedArticles = Object.values(userArticles).reduce((acc, entry) => [...acc, ...entry.data], []);
    try {
      fetch('/manage/user_articles/import_user_articles', getFetchOptions(flattenedArticles))
        .then(handleErrors)
        .then(response => response.json())
        .then(data => {
          if (data['error']) {
            setError(data['error']['message'])
            return
          }
          setError("会員住戸を更新しました")
          window.location.reload()
        })
    }
    catch (error) {
      setError("会員住戸を更新できませんでした")
    }
  }

  const handleRadioChange = (event, article) => {
    const status = event.target.value
    const updatedArticles = { ...userArticles }

    Object.keys(updatedArticles).forEach(index => {
      updatedArticles[index].data = updatedArticles[index].data.map(item => {
        if (item.id === article.id) {
          return { ...item, status: status }
        }
        return item
      })
    })
    setUserArticles(updatedArticles)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    updateUserArticles()
  }

  const StatusMessage = ({ importedName, memberName }) => {
    const namesMatch = importedName === memberName;
    return namesMatch ? (
      <div className="status-match">
        <div className="status-text">一致につきステータス更新</div>
        <div className="arrow-container">
          <div className="arrow-line">
            <div className="arrow-head" />
          </div>
        </div>
      </div>
    ) : (
      <div className="status-mismatch">
        <div>氏名不一致につき</div>
        <div>DBからステータス更新なし</div>
      </div>
    );
  };

  return (
    <div>
      <h1>会員住戸を更新する</h1>
      <p>
        <a format="csv" className="button" href="/manage/user_articles/download_user_article_csv_format">フォーマットダウンロード</a>
      </p>
      <h1>アップロードするCSVファイルを選択してください。</h1>
      <p>
        <input
          type="file"
          className="form-control"
          {...props}
          onChange={(e) => onChangeUserArticleFile(e)}
        />
      </p>
      {!error && Object.keys(userArticles).length > 0 ? (
        <div>
        <p>
          <strong>以下のデータをご確認ください</strong>
        </p>
        <table id="userArticleCSVpreview" className="csv-preview-table">
          <thead>
            <tr>
              <th>マンションID</th>
              <th>物件名</th>
              <th>号室</th>
              <th>インポート入力氏名</th>
              <th>会員住戸 氏名</th>
              <th></th>
              <th>会員住戸</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(userArticles).map(([index, entry]) => {
              return entry.data.map((article, subIndex) => (
                <tr
                  key={`row[${index}-${article.id}]`}
                  className={
                    entry.data.length > 1
                    ? `group-row group-${index} ${subIndex === 0 ? 'first-row' : subIndex === entry.data.length - 1 ? 'last-row' : 'middle-row'}`
                    : ''
                  }
                >
                  <td>{subIndex === 0 ? article.apartment_id : ''}</td>
                  <td>{subIndex === 0 ? article.article_name : ''}</td>
                  <td>{subIndex === 0 ? article.room : ''}</td>
                  <td>{subIndex === 0 ? article.name : ''}</td>
                  <td>{article.member_name}</td>
                  <td style={{ minWidth: '200px' }}>
                    <StatusMessage
                      importedName={article.name}
                      memberName={article.member_name}
                    />
                  </td>
                  <td>
                    <div key={`${index}-${article.id}`} className='user_article_status'>
                      <label>
                        <input
                          type="radio"
                          name={`user_article_status[${index}-${article.id}]`}
                          value="disabled"
                          checked={article.status === 'disabled'}
                          onChange={(event) => handleRadioChange(event, article)}
                        /> 無効
                      </label>
                      <label>
                        <input
                          type="radio"
                          name={`user_article_status${index}-${article.id}]`}
                          value="enabled"
                          checked={article.status === 'enabled'}
                          onChange={(event) => handleRadioChange(event, article)}
                        /> 有効
                      </label>
                    </div>
                  </td>
                </tr>
              ));
            })}
          </tbody>
        </table>
        <p>
          <button type="submit" className="button btn-update" onClick={handleSubmit}>以上の会員住戸を更新する | 一括登録する</button>
        </p>
        </div>
      )
      : (
      <p>
        { error && <strong>{error}</strong> }
      </p>
      )
      }
    </div>
  )
}

export default ImportUserArticleForm
